module.exports = __webpack_public_path__ + "img/1726035185442-screenshot-1726035170215.png.a53330c1.webp";